/**
 * Created with Lightsaber and Force.
 * User: yaroslav
 * Date: 9/16/15
 * Time: 2:30 PM
 * with Love for Angular & Angular UI
 *
 */
(function(angular){
var module = angular.module('uiPopoverExt', ['ui.bootstrap']);

    module
        .directive('popoverToggle', ['$timeout', function($timeout) {
            return {
                scope: true,
                link: function(scope, element, attrs) {
                    scope.toggle = scope.dismiss = function() {
                        element.scope().isPopoverOpen = !element.scope().isPopoverOpen;
                    };
                }
            };
        }]);

})(angular);